<script lang="ts" setup>
import { tokenService } from '~/api/service/token.service'
import { TETHER_USDT_TOKEN } from '~/constants/token.constants'
import { tokenDetailPageTab } from '~/routes/tokens'
import { type ITab } from '~/types/tab.type'
import { ITokenType } from '~/types/token-type.type'
import BcTabs from '~/ui/Tabs/BcTabs.vue'

type ITokenTab = ITab<tokenDetailPageTab> & {
  activeTypeList: Array<ITokenType>
}

const route = useRoute()
const router = useRouter()

const address = route.params.address as string

const { data } = tokenService.useGetTokenDetail(address, ITokenType.ERC20)
const tabList = computed(() => {
  const tab: ITokenTab[] = [
    {
      value: tokenDetailPageTab.transfers,
      label: 'Transfers',
      activeTypeList: [ITokenType.ERC20],
    },
    // USDT만 Holders 데이터 제공 (2026-02-12)
    ...(address.toLowerCase() === TETHER_USDT_TOKEN.address.toLowerCase() ? [{
      value: tokenDetailPageTab.holders,
      label: 'Holders',
      activeTypeList: [ITokenType.ERC20],
    }] : []),
    {
      value: tokenDetailPageTab['contract-code'],
      label: 'Contract Code',
      activeTypeList: [ITokenType.ERC20],
    },
    {
      value: tokenDetailPageTab.info,
      label: 'Token Info',
      activeTypeList: [ITokenType.NATIVE, ITokenType.ERC20],
    },
  ]
  return tab.filter((tab: ITokenTab) => tab.activeTypeList.includes(data.value?.tokenType || ITokenType.ERC20))
})

const extractTabFromPath = (path: string) => {
  return path.split('/').at(-1) as tokenDetailPageTab || tokenDetailPageTab.transfers
}

const tab = ref(extractTabFromPath(route.path))

watch(tab, () => {
  router.replace(routes.getTokensDetailPageWithTab(address, tab.value))
})
</script>

<template>
  <BcTabs
    v-model="tab"
    :list="tabList"
  />
</template>

<style scoped>

</style>
